import LoaderImg from "../assets/images/loader.gif";

function Loader() {
  return (
   <>
   <div className="loader-img">
     <img src={LoaderImg} alt="" width={100} height={100} />
   </div>
   </>
  );
}

export default Loader;
